export interface MarketplaceCategory {
  _id: string;
  label: string;
  value: string;
}

export interface PerformancePoint {
  month: string;
  value: number;
}

export interface MarketplaceAsset {
  _id: string;
  name: string;
  issuer: string;
  category: string;
  status: string;
  targetYield: number;
  term: string;
  minInvestment: number;
  aum: number;
  region: string;
  currency: string;
  summary: string;
  sparkline: number[];
  performance: PerformancePoint[];
  documents: string[];
  risks: string[];
  featured: boolean;
  isActive?: boolean;
  createdAt?: string;
}

export const ASSET_STATUSES = ['Live', 'Closing soon', 'Closed'];
export const ASSET_CURRENCIES = ['USD', 'EUR', 'GBP'];
